import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CardLayout } from '@/modules/common/components';
import { AppIcon } from '@/modules/common/components/icons';
import theme from '@/styles/theme';

const PublicErrorCard = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CardLayout height="flex-grow">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AppIcon />
          <Typography variant="h5" sx={{ mt: 2 }}>
            {t('modules.common.publicErrorCard.title1')}
          </Typography>
          <Typography variant="h5" textAlign="center">
            {t('modules.common.publicErrorCard.title2')}
          </Typography>
          <Typography
            variant="body1"
            textAlign="center"
            color={theme.palette.colors.lightGrey}
            sx={{ mt: 2 }}
          >
            {t('modules.common.publicErrorCard.description1')}
          </Typography>
          <Typography
            variant="body1"
            textAlign="center"
            color={theme.palette.colors.lightGrey}
            sx={{ mt: 2 }}
          >
            {t('modules.common.publicErrorCard.description2')}
            <Link href="mailto:support@mavue.io">support@mavue.io</Link>
            {t('modules.common.publicErrorCard.description3')}
          </Typography>
        </Box>
      </CardLayout>
    </Box>
  );
};

export default PublicErrorCard;
